import { useEffect, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Checkbox from 'components/Checkbox/Checkbox';

import { STANDARD_ID } from '../../../../../../constants/formFields';
import { useGetStandardsQuery } from '../../../../../../store/slices/survey/apis/surveyApi';
import CreateSurveyItemPanel from './CreateSurveyItemPanel';

import type { ICreateSurveyStandardsProps } from '../interfaces/ICreateSurveyStandards';

import styles from '../scss/CreateSurvey.module.scss';

function CreateSurveyStandards({
  control, onRemove, standardId, setValue,
}: ICreateSurveyStandardsProps) {
  const { t } = useTranslation();
  const { data } = useGetStandardsQuery({});
  const items = useMemo(() => data?.data?.items || [], [data]);

  useEffect(() => {
    if (items.length > 0 && standardId) {
      setValue(STANDARD_ID, standardId);
    }
  }, [items, control, setValue, standardId]);

  return (
    <CreateSurveyItemPanel
      title={t('materialityAssessment.prioritizeStandards.title')}
      description={t('materialityAssessment.prioritizeStandards.subTitle')}
      onDelete={onRemove}
    >
      <div className={styles.standardsList}>
        <Controller
          control={control}
          name={STANDARD_ID}
          defaultValue={undefined}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <>
              {items.map((item) => (
                <div
                  className={styles.listItem}
                  key={`standard_${item.id}`}
                >
                  <Checkbox
                    name={`${name}_${item.id}`}
                    type="radio"
                    value={item.id}
                    checked={Number(value) === item.id}
                    label={item.name}
                    onChange={() => onChange(item.id)}
                  />
                </div>
              ))}
              {error ? <p className={styles.standardError}>{error?.message}</p> : null}
            </>
          )}
        />
      </div>
    </CreateSurveyItemPanel>
  );
}

export default CreateSurveyStandards;
